import { render, staticRenderFns } from "./data-subject-preference-expansion-panels.vue?vue&type=template&id=8cb1955c"
import script from "./data-subject-preference-expansion-panels.vue?vue&type=script&lang=js"
export * from "./data-subject-preference-expansion-panels.vue?vue&type=script&lang=js"
import style0 from "./data-subject-preference-expansion-panels.vue?vue&type=style&index=0&id=8cb1955c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports